import { UserSite } from '../site/site.interfaces';

export interface User {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	telephoneNumber?: string;
	mapKitToken: string;
	profile: Profile;
	sites: UserSite[];
	roles: any[];
	fullName?: string;
	capabilityName?: string;
}

export interface Profile {
	id: string;
	defaultSiteId: string;
	acceptedEula: boolean;
}

export interface Role {
	description: string;
}

export interface NewUser {
	id?: string;
	email: string;
	firstName: string;
	lastName: string;
	site: UserSite;
}

export class SimpleUser {
	id: string;
	name: string;
	email: string;
	firstName: string;
	lastName: string;
}